import React from "react";
import Modal from "react-modal";
import "./ContextMenu.scss";

Modal.setAppElement("#root");

const ContextMenu = (props) => {
  if (props.disableDeleteContextMenu) return <div />;
  return (
    <tr>
      <td>
        <ul
          className="context-menu"
          style={{
            position: "fixed",
            top: props.clientYDelete - 10,
            left: props.clientXDelete + 13,
            display: props.showMenu ? "" : "none",
          }}
        >
          <li
            style={{ fontSize: "14px" }}
            onClick={() => {
              props.deleteTicker();
            }}
          >
            Delete
          </li>
        </ul>
      </td>
    </tr>
  );
};

export default React.memo(ContextMenu);
